<div class="container">
  <ng-container *ngIf="!content.loading">
    <ng-container *ngFor="let message of content.messages">
      <app-assistant-banner-content-message
        class="message"
        [message]="message"
      ></app-assistant-banner-content-message>
    </ng-container>
  </ng-container>
  <div
    class="loading-wrapper"
    *ngIf="content.loading"
  >
    <mat-icon
      class="loading"
      [svgIcon]="brandingService.logoMarkOutlineIcon"
    ></mat-icon>
  </div>
</div>
